import { render, staticRenderFns } from "./SalesPointModalForm.vue?vue&type=template&id=f2f8e3c8"
import script from "./SalesPointModalForm.vue?vue&type=script&lang=js"
export * from "./SalesPointModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports